import { MAX_VIDEO_DURATION_SECONDS } from './constants';

/**
 * Check video file duration before uploading.
 * Returns the duration in seconds if valid, throws Error if too long.
 *
 * When the browser cannot read metadata (unusual codec, DRM, etc.),
 * resolves with 0 so the server can perform its own validation.
 *
 * The default maxSeconds matches MAX_VIDEO_DURATION_SECONDS (constants.ts),
 * which must stay in sync with the backend SPORTFORM_MAX_VIDEO_DURATION env
 * var (default 60 s, paths.py).
 */
export async function validateVideoDuration(
  file: File,
  maxSeconds: number = MAX_VIDEO_DURATION_SECONDS,
): Promise<number> {
  return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);
      if (video.duration > maxSeconds) {
        reject(
          new Error(
            `Video is ${video.duration.toFixed(1)}s long. Maximum allowed is ${maxSeconds}s. Please trim your video before uploading.`
          )
        );
      } else {
        resolve(video.duration);
      }
    };
    video.onerror = () => {
      URL.revokeObjectURL(video.src);
      // Cannot determine duration client-side — let server validate
      resolve(0);
    };
    video.src = URL.createObjectURL(file);
  });
}
